module.exports = __webpack_public_path__ + "img/timer-start.addd7634.svg";